import React, { useEffect, useState } from "react";
import ProjectDocumentService from "../Services/ProjectDocumentService";

const FolderTree = ({ orgId, projectId, onSelect }) => {
  const [folders, setFolders] = useState([]);

  useEffect(() => {
    loadRoot();
  }, []);

  const loadRoot = async () => {
    const res = await ProjectDocumentService.listDocuments(
      orgId,
      projectId,
      ""
    );
    setFolders(res.data.filter((i) => i.folder));
  };

  return (
    <div style={{ borderRight: "1px solid #ddd", paddingRight: 10 }}>
      {folders.map((f) => (
        <div
          key={f.relativePath}
          style={{ cursor: "pointer", padding: "4px 0" }}
          onClick={() => onSelect(f.name)}
        >
          📁 {f.name}
        </div>
      ))}
    </div>
  );
};

export default FolderTree;
